import React, { Component } from "react";
import { connect } from "react-redux";

import AdminLink from "../app/AdminLink";

class Queries extends Component {

  render() {
    return (
      <AdminLink />
    );
  }
}
/********* Container part */

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Queries);



// WEBPACK FOOTER //
// ./src/queries/Queries.js